(function ($) {
    $(() => {
        var scrollPos = 0;

        $('.navbar-toggler').on('click', function () {
            $('.navbar-collapse').toggleClass('is-opened');
            $('.navbar-toggler').toggleClass('is-active');

            if ($('.navbar-collapse').hasClass('is-opened')) {
                scrollPos = $(window).scrollTop();
                $('body').css({
                    overflow: 'hidden',
                    position: 'fixed',
                    width: '100vw',
                    top: -scrollPos
                });
            } else {
                $('body').css({
                    overflow: '',
                    position: 'relative',
                    top: ''
                });
                $(window).scrollTop(scrollPos);
            }
        });
        $('.menu-item a').click(function () {
            $('.navbar-toggler').removeClass('is-active');
            $('.navbar-collapse').removeClass('is-opened');
            $('body').css({
                overflow: '',
                position: 'relative',
                top: ''
            });
        });
    });
})(jQuery);
